import React, { useCallback, useEffect, useState } from 'react';
import { ModalToggle, Typography } from 'ck-ui';

const Prop65Warning = () => {
  const getGeoFromStorage = useCallback(() => sessionStorage['ck-user-country-code'] || null, []);
  const [userCountryCode, setUserCountryCode] = useState(getGeoFromStorage());

  useEffect(() => {
    const updateGeoLocation = () => setUserCountryCode(getGeoFromStorage());
    if (!userCountryCode) {
      window.addEventListener('geoLocationReady', updateGeoLocation);
    }
    return () => {
      window.removeEventListener('geoLocationReady', updateGeoLocation);
    };
  }, [userCountryCode, getGeoFromStorage]);

  return (userCountryCode === 'US')
    ? (
      <p>
        ⚠️
        <span className="is-italic">WARNING:{' '}
          <ModalToggle
            className="is-inline underline has-text-weight-bold"
            modalProps={{ isTabletAboveFixedSize: true }}
            renderAs="a"
            label="Click here"
          >
            <div className="section">
              <Typography variant="heading5">⚠️WARNING:</Typography>
              <br />
              <p>
                This product can expose you to Lead, which is known in the State of California to cause cancer, birth defects or other reproductive harm.
                For more information go to
                {' '}
                <a className="underline" href="https://www.p65warnings.ca.gov/" target="_blank" rel="noopener noreferrer">https://www.p65warnings.ca.gov</a>.
                <br /><br />
                We care deeply about your wellbeing and while we are doing everything we can to avoid the use of harmful chemicals during manufacturing,
                some of our products may contain very small traces of lead or other chemicals.
              </p>
            </div>
          </ModalToggle>
          {' '}to view California Prop 65 information.
        </span>
      </p>
    ) : null;
};

export { Prop65Warning };
